const BOOKING_EVENTS = {
  FILTERED_BY_POD: 'Filtered by Pod',
  FILTERED_BY_ME: 'Filtered by My Loads',
  FILTERED_OWN_ISSUES: 'Filtered by Issues I Own',
  CLEARED_SEARCH: 'Clicked Clear Filters',
  SUBMIT_SEARCH: 'Clicked Search Shipments',
  SORTED: 'Sorted',
  VIEWED_NEARBY_RELOADS: 'Viewed loads picking up nearby on Shipment Panel',
  VIEWED_RELOADS: 'Viewed reloads on Shipment Panel',
  CLICKED_EDIT_POST: 'Clicked Save on Edit DAT Post Side Panel',
  CLICKED_ADD_POST: 'Clicked Add Post in Active Posts',
  CLICKED_DELETE_POST: 'Clicked Delete Post in Active Posts',
  CLICKED_SAVE_MARKETPLACE_SETTINGS: 'Clicked Save Marketplace Settings',
  OPENED_MARKETPLACE_SETTINGS_MODAL: 'Opened Marketplace Settings Modal',
  OPENED_EDIT_DAT_POST_MODAL: 'Opened Edit DAT Post Modal',
  UPDATED_SORT_BY_FILTER: 'Updated Sort By Filter on Carrier List',
  UPDATED_PICKUP_RADIUS_FILTER: 'Updated Pickup Radius Filter on Carrier List',
  UPDATED_DELIVERY_RADIUS_FILTER: 'Updated Delivery Radius Filter on Carrier List',
  UPDATED_MATCH_TYPE_FILTER: 'Updated Match Type Filter on Carrier List',
  UPDATED_BOOKED_WITH_ME_FILTER: 'Updated Booked with me Filter on Carrier List',
  CLICKED_DOWNLOAD_CSV: 'Clicked Download CSV on Carrier List',
  CLICKED_COVER_CTA: 'Clicked "Cover" from Side Panel',
  COMPLETE_STEP_1: 'Clicked "Cover Load"',
  COMPLETE_STEP_2: 'Clicked "Save"',
  CHANGE_TRUCK_NUMBER: 'Changed Truck Number',
} as const

const CX_TASKS_EVENTS = {
  SHIPMENT_LINK_CLICKED: 'Shipment Clicked',
  SHIPPER_SEARCH: 'CX Task List: Searched by Shipper',
  QUERY_SEARCH: 'CX Task List: Searched by ID, PO, BOL',
  CLICK_SHIPMENT_ACTIONS: 'Side Panel: Click Shipment Actions',
  CHANGE_ACTIVE_TAB: 'Side Panel: Change tab',
  SHIPMENT: 'Side Panel: Shipment Section',
  APPOINTMENTS: 'Side Panel: Appointments Form',
  NOTES: 'Side Panel: Notes Form',
} as const

const DETENTION_REVIEW_EVENTS = {
  SUBMITTED_DETENTION_FORM: 'Submitted New Detention Form',
} as const

const SPECIFIC_LANE_EVENTS = {
  PU_SEARCH: 'PU Search Area Clicked on Specific Lane',
  DEL_SEARCH: 'DEL Search Area Clicked on Specific Lane',
  PU_RADIUS_SEARCH: 'PU Radius Search Area Clicked on Specific Lane',
  DEL_RADIUS_SEARCH: 'DEL Radius Search Area Clicked on Specific Lane',
  SHIPPER_SEARCH: 'Filtered by Shipper on Specific Lane',
  OPS_REP_SEARCH: 'Filtered by Ops Rep on Specific Lane',
  CARRIER_SEARCH: 'Filtered by Carrier on Specific Lane',
  EQUIPMENT_TYPE_SEARCH: 'Filtered by Equipment Type on Specific Lane',
  PICKUP_REGION_SEARCH: 'Filtered by Pickup Region on Specific Lane',
  DELIVERY_REGION_SEARCH: 'Filtered by Delivery Region on Specific Lane',
  SEARCH_TYPE: 'Filtered by Search Type on Specific Lane',
  CLICKED_ASSIGNED_TO_ME: 'Clicked Assigned to Me on Specific Lane',
  CLICKED_MY_CARRIERS: 'Clicked My Carriers on Specific Lane',
  CLICKED_MY_RATES: 'Clicked My Rates on Specific Lane',
  CLICKED_ROW: 'Clicked Row on Specific Lane',
  SORT_COLUMN: 'Sort Column on Specific Lane',
  CLICKED_TO_OPEN_GET_CALL_LIST: 'Clicked to Open Modal to Get a Call List',
  CLICKED_TO_REQUEST_CALL_LIST: 'Clicked to Request a Call List from modal',
  CLICKED_TO_VISIT_SHIPMENT_LIST: 'Clicked Link to Visit Shipment List on Specific Lane',
  VIEWED_LANE_ALERTS: 'Viewed Lane Alerts in Routing Guide',
  VIEWED_RESERVED_CARRIERS: 'Viewed Reserved Carriers in Routing Guide',
  OPENED_EDIT_ORDER_MODAL: 'Clicked Edit Order Modal in Routing Guide',
  CLICKED_ADD_LANE_RATE: 'Clicked Add New Carrier in Routing Guide',
  CLICKED_EDIT_LANE_RATE: 'Clicked Edit Rate on Row in Routing Guide',
  CLICKED_REMOVE_LANE_RATE: 'Clicked Remove Rate on Row in Routing Guide',
  CLICKED_APPROVE_LANE_RATE: 'Clicked Approve Contract Rate on Row in Routing Guide',
  CLICKED_UNAPPROVE_LANE_RATE: 'Clicked Unapprove Contract Rate on Row in Routing Guide',
  CLICKED_DOWNLOAD_CSV: 'Clicked to download a Carrier List CSV in Routing Guide',
} as const

const RFP_LANES_EVENTS = {
  FILTER_RFP_LANE_RATE: 'Filtered on Search RFP Lane Rate',
  SORTED_RFP_LANE_RATE: 'Sorted on Search RFP Lane Rate',
  CLICKED_EDIT_RATE: 'Clicked Edit Rate on Sourced Rates',
  CLICKED_DELETE_RATE: 'Clicked Delete Rate on Sourced Rates',
  CLICKED_ADD_SOURCED_RATE: 'Clicked Add Sourced Rate',
  FILTER_BY_RFP_LANE: 'Filtered on Search RFP Lane',
  SELECTED_SEARCH_RESULT: 'Selected a Search RFP Lane result',
  CONTINUED_ADD_RATE_MODAL: 'Clicked "Continue" on Add Sourced Rate Modal',
  CLOSED_ADD_RATE_MODAL: 'Closed the Add Sourced Rate Modal',
  BACK_ADD_RATE_MODAL: 'Clicked the back button on Add Sourced Rate Modal',
  SAVED_ADD_RATE_MODAL: 'Clicked the Save button on Add Sourced Rate Modal',
  BULK_ADD_RATE: 'Uploaded Bulk Add Rates in Sourced Rates',
  BULK_EDIT_RATE: 'Uploaded Bulk Edit Rates in Sourced Rates',
} as const

const SHIPMENT_DETAILS_V2 = {
  BACK_TO_STARK_VIEW: 'Back to old shipment details view',
} as const

const EXPANDED_MAPS_EVENTS = {
  CLICKED_MAP_AND_PINGS_TAB: 'Clicked maps and pings tab',
  CLICKED_PING_IN_PINGS_LIST: 'Clicked ping in pings list',
  CLICKED_PING_IN_MAP: 'Clicked ping in map',
} as const

const CARRIER_APPLICATION = {
  CLICKED_USER_VALIDATION_CHECKBOX: 'Clicked User Validation Checkbox',
} as const

const CARRIER_OPTIONS = {
  ADDED_NON_BOOKABLE_OPTION: 'Created a non-bookable carrier option',
  ADDED_OPTION: 'Created new carrier option',
  ERROR_ADDING_OPTION: 'Error creating new carrier option',
  EDITED_OPTION: 'Edited existing carrier option',
  ERROR_EDITING_OPTION: 'Error editing existing carrier option',
  DECLINED_OPTION: 'Declined carrier option',
  ERROR_DECLINING_OPTION: 'Error declining carrier option',
  REACTIVATED_OPTION: 'Marked carrier option as available',
  ERROR_REACTIVATING_OPTION: 'Error reactivating carrier option',
  ACCEPTED_INBOUND_OPTION: 'Accepted inbound option',
  ERROR_ACCEPTING_INBOUND_OPTION: 'Error accepting inbound carrier option',
  ERROR_ACCEPTING_NON_COMPLIANT_INBOUND_OPTION:
    'Error accepting non-compliant inbound carrier option',
  COVERED_SHIPMENT_WITH_NON_COMPLIANT_INBOUND_OPTION:
    'Covered shipment with a non-complaint carrier with inbound option',
  COVERED_SHIPMENT_WITH_OUTBOUND_OPTION: 'Covered shipment with existing outbound option',
  ERROR_COVERING_SHIPMENT_WITH_OUTBOUND_OPTION: 'Error covering shipment with outbound option',
  OFFERED_SHIPMENT_WITH_OUTBOUND_OPTION: 'Offered shipment with existing outbound option',
  ERROR_OFFERING_SHIPMENT_WITH_OUTBOUND_OPTION: 'Error offering shipment with outbound option',
  REQUESTED_OPTION_APPROVAL: 'Requested option approval',
  ERROR_REQUESTING_OPTION_APPROVAL: 'Error requesting option approval',
  REJECTED_OPTION_APPROVAL: 'Rejected option approval',
  ERROR_REJECTING_OPTION_APPROVAL: 'Error rejecting option approval',
  APPROVED_OPTION_APPROVAL: 'Approved option approval',
  ERROR_APPROVING_OPTION_APPROVAL: 'Error approving option approval',
  ADDED_COUNTER_OFFER: 'Created new counter offer',
  ERROR_ADDING_COUNTER_OFFER: 'Error creating new counter offer',
  EDITED_COUNTER_OFFER: 'Edited counter offer',
  ERROR_EDITING_COUNTER_OFFER: 'Error editing counter offer',
  DELETED_COUNTER_OFFER: 'Deleted counter offer',
  ERROR_DELETING_COUNTER_OFFER: 'Error deleting counter offer',
  TOTAL_OPTIONS_GREATER_THAN_PAGESIZE: 'Available Carrier Options exceed the page size limit',
} as const

const SHIPMENT_WATERFALL = {
  WATERFALL_RESTARTED_SUCCESSFULLY: 'Waterfall has been restarted.',
  ERROR_RESTARTING_WATERFALL: 'Error restarting waterfall.',
  SHIPMENT_REOFFERED: 'Shipment was manually reoffered to carrier.',
  ERROR_REOFFERING_SHIPMENT: 'Error reoffering shipment to carrier.',
  CARRIER_SKIPPED: 'Carrier has been manually skipped in waterfall',
  ERROR_SKIPPING_CARRIER: 'Error skipping carrier in waterfall',
} as const

const CARRIER_EVENTS = {
  HIGHWAY_MANUAL_SYNC_SUCCESS: 'Highway Manual Sync Success',
  HIGHWAY_MANUAL_SYNC_FAILURE: 'Highway Manual Sync Failure',
}

const COMMUNICATION_EVENTS = {
  ERROR_STARTING_PHONE_CALL: 'Error starting phone call',
}

export const MP_ANALYTICS_EVENTS = {
  Booking: { ...BOOKING_EVENTS },
  'CX Tasks': { ...CX_TASKS_EVENTS },
  'Detention Review': { ...DETENTION_REVIEW_EVENTS },
  'Specific Lane': { ...SPECIFIC_LANE_EVENTS },
  'RFP Lanes': { ...RFP_LANES_EVENTS },
  'Shipment Details v2': { ...SHIPMENT_DETAILS_V2 },
  'Expanded Maps': { ...EXPANDED_MAPS_EVENTS },
  'Carrier Application': { ...CARRIER_APPLICATION },
  'Carrier Options': { ...CARRIER_OPTIONS },
  'Shipment Waterfall': { ...SHIPMENT_WATERFALL },
  Carrier: { ...CARRIER_EVENTS },
  Communication: { ...COMMUNICATION_EVENTS },
}
